import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import CreateUsers from '../components/settings/CreateUsers';
import ConfigureGoals from '../components/settings/ConfigureGoals';
import ManageBreeds from '../components/settings/ManageBreeds';
import ManageNeeds from '../components/settings/ManageNeeds';
import ManageConvenios from '../components/settings/ManageConvenios';
import LoadProceduresButton from '../components/LoadProceduresButton';
import ManageProcedures from '../components/ManageProcedures';
import ManageCapacities from '../components/settings/ManageCapacities';
import ManageSupplies from '../components/settings/ManageSupplies';
import ManageBranches from '../components/settings/ManageBranches';

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const Settings = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Configuración
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Administra usuarios, metas, razas, necesidades, convenios, sucursales y capacidades del sistema
      </Typography>

      <Paper sx={{ mt: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Crear Usuarios" />
          <Tab label="Configurar Metas" />
          <Tab label="Razas" />
          <Tab label="Necesidades" />
          <Tab label="Convenios" />
          <Tab label="Procedimientos Quirúrgicos" />
          <Tab label="Capacidades" />
          <Tab label="Insumos y Medicamentos" />
          <Tab label="Sucursales" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <CreateUsers />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <ConfigureGoals />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <ManageBreeds />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <ManageNeeds />
        </TabPanel>

        <TabPanel value={tabValue} index={4}>
          <ManageConvenios />
        </TabPanel>

        <TabPanel value={tabValue} index={5}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Gestione los procedimientos quirúrgicos disponibles en el sistema. Si es la primera vez,
              cargue los procedimientos estándar haciendo clic en el botón de abajo.
            </Typography>
            <Box sx={{ mt: 2 }}>
              <LoadProceduresButton />
            </Box>
          </Box>
          <ManageProcedures />
        </TabPanel>

        <TabPanel value={tabValue} index={6}>
          <ManageCapacities />
        </TabPanel>

        <TabPanel value={tabValue} index={7}>
          <ManageSupplies />
        </TabPanel>

        <TabPanel value={tabValue} index={8}>
          <ManageBranches />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default Settings;
